export enum WidgetTypeEnum {
  // Dashboard Widget Types
  PICTORIAL_CHART = 'PICTORIAL_CHART',
  BAR_CHART = 'BAR_CHART',
  PIE_CHART = 'PIE_CHART',
  LINE_CHART = 'LINE_CHART',
  DONUT_CHART = 'DONUT_CHART',
  COUNT = 'COUNT',
  STATUS_BOARD = 'STATUS_BOARD',
  REPO_STATS = 'REPO_STATS',
  GITWISER_SUMMARY = 'GITWISER_SUMMARY',
  COUNT_WITH_CHART = 'COUNT_WITH_CHART',
  STATUS_PROGRESS = 'STATUS_PROGRESS',
  BUILD_DETAILS = 'BUILD_DETAILS',
  JIRA_ISSUES = 'JIRA_ISSUES',
  TEXT_PANEL = 'TEXT_PANEL',
  CLOSED_MERGE_REQUESTS = 'CLOSED_MERGE_REQUESTS',
  PROJECT_MANAGEMENT_BOARDS = 'PROJECT_MANAGEMENT_BOARDS',
  SPRINT_WORK_DISTRIBUTION = 'SPRINT_WORK_DISTRIBUTION',
  SPRINT_SIZE = 'SPRINT_SIZE',
  CUSTOM_ECHARTS = 'CUSTOM_ECHARTS',
  CUSTOM_TEXT_PANEL = 'CUSTOM_TEXT_PANEL',
  TRANSACTION_CHART = 'TRANSACTION_CHART',
  CUSTOM_TABLE = 'CUSTOM_TABLE',
  SIMPLE_TABLE = 'SIMPLE_TABLE',
  SIMPLE_BAR_CHART = 'SIMPLE_BAR_CHART',
  DEPLOYMENT_LEAD_TIME_FOR_CHANGES = 'DEPLOYMENT_LEAD_TIME_FOR_CHANGES',
  FORTIFY_ISSUE_TABLE = 'FORTIFY_ISSUE_TABLE'
}
